import { render } from "./TabbyTodos.vue?vue&type=template&id=18f02468&scoped=true"
import script from "./TabbyTodos.vue?vue&type=script&lang=js"
export * from "./TabbyTodos.vue?vue&type=script&lang=js"

import "./TabbyTodos.vue?vue&type=style&index=0&id=18f02468&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18f02468"

export default script